import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class DauerUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'dauer';

  constructor() {
    super(DauerUrlService.URL_PARAMETER, 'dauer');
  }
}
